import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileInputTypeComponent } from './file-input-type.component';
import { FormlyModule } from '@ngx-formly/core';
import {
  AvatarModule,
  ButtonModule,
  CircularProgressModule,
  FileDragAndDropModule,
  ImageComponent,
  LinkDirective,
} from '@lockton-apps/shared/ui/lui';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [FileInputTypeComponent],
  imports: [
    CommonModule,
    FileDragAndDropModule,
    ReactiveFormsModule,
    MatIconModule,
    AvatarModule,
    LinkDirective,
    ImageComponent,
    ButtonModule,
    MaterialModule,
    CircularProgressModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'file-input',
          component: FileInputTypeComponent,
          wrappers: ['addons'],
          defaultOptions: {
            props: {
              tooltip: {
                text: $localize`Accepted formats: WORD, EXCEL, CSV, JPEG, PNG, PDF, POWERPOINT, MSG. File size limit: 20MB.`,
              },
              accept: [
                {
                  name: 'WORD',
                  extensions: [
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  ],
                },
                {
                  name: 'EXCEL',
                  extensions: [
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                  ],
                },
                {
                  name: 'CSV',
                  extensions: ['application/csv'],
                },
                {
                  name: 'JPEG',
                  extensions: ['image/jpeg'],
                },
                {
                  name: 'PNG',
                  extensions: ['image/png'],
                },
                {
                  name: 'PDF',
                  extensions: ['application/pdf'],
                },
                {
                  name: 'POWERPOINT',
                  extensions: [
                    'application/vnd.ms-powerpoint',
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                  ],
                },
                {
                  name: 'MSG',
                  extensions: ['application/vnd.ms-outlook'],
                },
              ],
              filesizeLimit: 20 * 1024 * 1024,
              filesizeLimitDescription: '20MB',
            },
          },
        },
      ],
    }),
  ],
})
export class FileInputTypeModule {}
